const BlockCookieUi = () => {
  const mainCntCss = `
    .errorImage{
      height:200px
    }
    .contentCnt{
      margin:10px 0
    }
    @media (min-width: 576px) {
      .errorImage{
          height:300px
        }
      .contentCnt{
          margin:40px 0 10px 0
        }
      }
      `;
  return (
    <>
      <div
        style={{
          padding: "15px",
          boxShadow: "-1px 1px 0 2px #EBF0F2",
          height: "61px"
        }}
      >
        <img src="/hire/logo-mobile.svg" alt="jobhai.com logo" />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          width: "100%",
          textAlign: "center",
          minHeight: "200px",
          padding: "6%"
        }}
      >
        <style>{mainCntCss}</style>
        <img
          src="/hire/error.svg"
          className="errorImage"
          style={{
            width: "60% "
          }}
        />
        <div
          style={{
            fontSize: "24px",
            fontWeight: 700
          }}
          className="contentCnt"
        >
          Please allow cookies to use Job Hai
        </div>
        <p
          style={{
            fontSize: "16px",
            fontWeight: 400,
            width: "82%",
            margin: "0 auto"
          }}
        >
          Cookies are small pieces of text sent to your browser by a website you
          visit. It helps us remember information about your visit, which can
          both make it easier to visit our website again and make the site more
          useful to you.
        </p>
      </div>
    </>
  );
};

export default BlockCookieUi;
